import { render, staticRenderFns } from "./UserBadgeName.vue?vue&type=template&id=4e1f8ac4"
import script from "./UserBadgeName.vue?vue&type=script&lang=js"
export * from "./UserBadgeName.vue?vue&type=script&lang=js"
import style0 from "./UserBadgeName.vue?vue&type=style&index=0&id=4e1f8ac4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports